import { Component, HostListener, Input, ViewChild, ElementRef } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { ConfirmExitDialogComponent } from '../../components/confirm-exit-dialog/confirm-exit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FeriadosComponent } from '../../feriados/feriados.component';

@Component({
  selector: 'app-navegacion',
  templateUrl: './navegacion.component.html',
  styleUrls: ['./navegacion.component.scss']
})
export class NavegacionComponent {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input("todas_opciones") todas_opciones: boolean = false;
  @Input("ruta_volver") ruta_volver: string = "/config/home";
  @Input("sub_titulo") sub_titulo: string = "";

  someMethod() {
    this.trigger.openMenu();
  }

  menuItems = [];
  itemDesplegado: any;

  constructor(private readonly router: Router,
    private eRef: ElementRef,
    private readonly dialog: MatDialog, 
  ) { }

  ngOnInit() {
    this.organizarMenu();
  }

  organizarMenu(): void {
    if (this.todas_opciones) {
      this.menuItems = [
        {
          label: 'Administrador general',
          open: false,
          subItems: [
            { label: 'Feriados', link: '/config/feriados' },
            { label: 'Gestión de destinatarios', link: '/config/destinatarios' },
            { label: 'Gestión de validaciones', link: '/config/validaciones' }
          ]
        },
        {
          label: 'Asistentes',
          open: false,
          subItems: [
            { label: 'Nuevo menú', link: '/config/asistentemenu' },
            { label: 'Nuevo chat', link: '/config/asistentechat' },
            { label: 'Nuevo formulario', link: '/config/asistenteformulario' }
          ]
        }
      ];
    } else {
      this.menuItems = [
        {
          label: 'Volver',
          link: this.ruta_volver,
          open: false,
        }]
    }
  }



  toggleSubmenu(item: any, event: MouseEvent) {
    event.stopPropagation();

    if (item.subItems && item.subItems.length > 0) {
      this.menuItems.forEach(i => i.open = false);
      item.open = !item.open;
      this.itemDesplegado = item;
    } else {
      if (item.label === 'Volver' && window.location.pathname.includes('/config/feriados')) {
        const feriados = FeriadosComponent.instancia;

        if (feriados?.hayCambiosSinGuardar()) {
          const dialogRef = this.dialog.open(ConfirmExitDialogComponent, {
            width: '400px'
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result === 'save') {
              feriados.guardarDesdeNavegacion(() => {
                this.router.navigate([this.ruta_volver]);
              });


            } else if (result === 'exit') {
              this.router.navigate([this.ruta_volver]);
            }
          });

          return;
        }
      }

      this.router.navigate([item.link || this.ruta_volver]);
    }
  }



  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // si se hizo click fuera del menú, se cierra el menú desplegado
    if (!this.eRef.nativeElement.contains(event.target)) {

      this.menuItems.forEach(item => item.open = false);
    }
  }
}

